import { render } from "./pagination.vue?vue&type=template&id=315ee3ca&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=315ee3ca&scoped=true&lang=scss"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315ee3ca"]])

export default __exports__